import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/prcsmntr/intusr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/prcs-mntr/int-usrs`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    // Internal user account processing status !== 내부 사용자 계정처리현황 목록 ==!
    ptli0601001q: `${BASE.path}/ptli0601001q`,
    // Internal user account processing status details !== 내부 사용자 계정처리현황 상세 목록 ==!
    ptli0601002q: `${BASE.path}/ptli0601002q`,
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get the list of internal user account processing status. !== 내부 사용자 계정처리현황 목록을 조회한다. ==!
    getIntUsrPrcsList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Get the list of internal user account processing status details. !== 내부 사용자 계정처리현황 상세 목록을 조회한다. ==!
    getIntUsrPrcsHistList: (usrDmnId: any, page: number, size: number) => {
        return api.get(`${BASE.api}/${usrDmnId}/hists?page=${page}&size=${size}`, {
            // params: comnUtils.toGetParams(data),
        });
    },

    // Get the excel list of internal user account processing status. !== 내부 사용자 계정처리현황 엑셀 목록을 조회한다. ==!
    getIntUsrPrcsExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),
};

export const SF_USR_SEARCH_FORM: TFormSchema = {
    id: "form_infoSrch",
    schema: {
        /* request date !== 요청일자 ==!*/
        reqDateRnge: {
            type: "daterange",
            label: "L_RQST_DT",
            start: { name: "reqTimeStart" },
            end: { name: "reqTimeEnd" },
            rangeButton: 4,
        },
        /* User Status !== 사용자 상태 ==!*/
        aplyStat: {
            type: "select",
            label: "L_USR_STAT_CD",
            all: true,
            area: "comnCd",
            comnCd: "PTL0001",
        },
        /* User domain ID !== 사용자 도메인 ID ==! */
        usrDmnId: {
            type: "text",
            label: "L_ID",
            edit: true,
        },
        /* User Name !== 사용자명 ==!*/
        usrNm: {
            type: "text",
            label: "L_NM",
            edit: true,
        },
        /* Tin !== 납세자 식별번호 ==!*/
        usrTin: {
            type: "text",
            label: "L_TIN",
            edit: true,
        },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO" },
    },
};

export const SG_USR_LIST: TGridSchema = {
    id: "grid_usrList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_ID", binding: "usrDmnId", width: "10%" }], id: "usrDmnId" },
        { cells: [{ header: "L_ID", binding: "intUsrAplyId", width: "10%" }], id: "intUsrAplyId", show: false },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "15%" }], id: "usrNm" },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "10%" }] },
        { cells: [{ header: "L_TIN", binding: "usrTin", width: "10%" }], id: "usrTin" },
        { cells: [{ header: "L_USR_HIST_CNT", binding: "usrHistCnt", width: "8%" }], id: "usrHistCnt" },
        { cells: [{ header: "L_SCTN", binding: "cstmSctnOrgzNm", width: "*" }], id: "cstmSctnOrgzNm" },
        { cells: [{ header: "L_CSTM", binding: "cstmOfceCd", width: "*" }], id: "cstmOfceCd" },
        { cells: [{ header: "L_UT", binding: "cstmUnitOrgzNm", width: "10%" }], id: "cstmUnitOrgzNm" },
        { cells: [{ header: "L_STAT", binding: "aplyStat", width: "8%" }], id: "aplyStat" },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }], id: "lastMdfrId" },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "10%" }], id: "lastMdfyDtm" },
    ],
    body: [
        {
            cells: [{ binding: "usrDmnId" }] /* User domain ID !== 사용자 도메인 ID ==! */,
        },
        {
            cells: [{ binding: "intUsrAplyId" }] /* Internal user application ID !== 내부 사용자 신청 아이디 ==! */,
        },
        {
            cells: [{ binding: "usrNm", align: "left" }] /* User Name !== 사용자명 ==! */,
        },
        {
            cells: [{ binding: "cstmOfcrNo" }],
        },
        {
            cells: [{ binding: "usrTin" }] /* Tin !== 납세자 식별번호 ==!*/,
        },
        {
            cells: [{ binding: "usrHistCnt", align: "center" }] /* number of modifications !== 수정 건수 ==! */,
        },
        {
            cells: [{ binding: "cstmSctnOrgzNm", align: "left" }] /* Tin !== 세관_섹션_조직_명 ==! */,
        },
        {
            cells: [{ binding: "cstmOfceCd", align: "left", type: "code", area: "cstmCd" }] /* Tin !== 세관_명 ==! */,
        },
        {
            cells: [{ binding: "cstmUnitOrgzNm" }] /* Tin !== 세관_섹션_유닛_명 ==! */,
        },
        {
            cells: [{ binding: "aplyStat" }] /* application status !== 신청 상태 ==! */,
        },
        {
            cells: [{ binding: "lastMdfrId", align: "left" }] /* Last Modifier User Id */,
        },
        {
            cells: [{ binding: "lastMdfyDtm", type: "datetime" }] /* Last Modifier Date And Time */,
        },
    ],
};

export const SG_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_usrExcelList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_ID", binding: "usrDmnId", width: "10%" }], id: "usrDmnId" },
        { cells: [{ header: "L_ID", binding: "intUsrAplyId", width: "10%" }], id: "intUsrAplyId", show: false },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "15%" }], id: "usrNm" },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "10%" }] },
        { cells: [{ header: "L_TIN", binding: "usrTin", width: "10%" }], id: "usrTin" },
        { cells: [{ header: "L_USR_HIST_CNT", binding: "usrHistCnt", width: "8%" }], id: "usrHistCnt" },
        { cells: [{ header: "L_SCTN", binding: "cstmSctnOrgzNm", width: "*" }], id: "cstmSctnOrgzNm" },
        { cells: [{ header: "L_CSTM", binding: "cstmOfceCd", width: "*" }], id: "cstmOfceCd" },
        { cells: [{ header: "L_UT", binding: "cstmUnitOrgzNm", width: "10%" }], id: "cstmUnitOrgzNm" },
        { cells: [{ header: "L_STAT", binding: "aplyStat", width: "8%" }], id: "aplyStat" },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }], id: "lastMdfrId" },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "10%" }], id: "lastMdfyDtm" },
    ],
    body: [
        {
            cells: [{ binding: "usrDmnId" }] /* User domain ID !== 사용자 도메인 ID ==! */,
        },
        {
            cells: [{ binding: "intUsrAplyId" }] /* Internal user application ID !== 내부 사용자 신청 아이디 ==! */,
        },
        {
            cells: [{ binding: "usrNm", align: "left" }] /* User Name !== 사용자명 ==! */,
        },
        {
            cells: [{ binding: "cstmOfcrNo" }],
        },
        {
            cells: [{ binding: "usrTin" }] /* Tin !== 납세자 식별번호 ==!*/,
        },
        {
            cells: [{ binding: "usrHistCnt", align: "center" }] /* number of modifications !== 수정 건수 ==! */,
        },
        {
            cells: [{ binding: "cstmSctnOrgzNm", align: "left" }] /* Tin !== 세관_섹션_조직_명 ==! */,
        },
        {
            cells: [{ binding: "cstmOfceCd", align: "left", type: "code", area: "cstmCd" }] /* Tin !== 세관_명 ==! */,
        },
        {
            cells: [{ binding: "cstmUnitOrgzNm" }] /* Tin !== 세관_섹션_유닛_명 ==! */,
        },
        {
            cells: [{ binding: "aplyStat" }] /* application status !== 신청 상태 ==! */,
        },
        {
            cells: [{ binding: "lastMdfrId", align: "left" }] /* Last Modifier User Id */,
        },
        {
            cells: [{ binding: "lastMdfyDtm", type: "datetime" }] /* Last Modifier Date And Time */,
        },
    ],
};

export const SG_USR_DTL_LIST: TGridSchema = {
    id: "grid_usrDtlList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_ID", binding: "usrDmnId", width: "10%" }], id: "usrDmnId" },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "15%" }], id: "usrNm" },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "10%" }], id: "cstmOfcrNo" },
        { cells: [{ header: "L_STAT", binding: "aplyStat", width: "10%" }], id: "aplyStat" },
        { cells: [{ header: "L_RTRN_RSN", binding: "aprvPrcssOpinCn", width: "*" }], id: "aprvPrcssOpinCn" },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }], id: "lastMdfrId" },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }], id: "lastMdfyDtm" },
    ],
    body: [
        {
            cells: [{ binding: "usrDmnId" }] /* Internal user application ID !== 내부 사용자 신청 아이디 ==! */,
        },
        {
            cells: [{ binding: "usrNm", align: "left" }] /* User Name !== 사용자명 ==! */,
        },
        {
            cells: [{ binding: "cstmOfcrNo" }] /* Tin !== 납세자 식별번호 ==! */,
        },
        {
            cells: [{ binding: "aplyStat" }] /* application status !== 신청 상태 ==! */,
        },
        {
            cells: [{ binding: "aprvPrcssOpinCn", align: "left" }] /* Reason for rejection !== 반려 사유 ==! */,
        },
        {
            cells: [{ binding: "lastMdfrId" }] /* Last Modifier User Id */,
        },
        {
            cells: [{ binding: "lastMdfyDtm", type: "datetime" }] /* Last Modifier Date And Time */,
        },
    ],
};
